import Image from 'next/image';
import React from 'react';
import { useRouter } from 'next/router';

const ConnectedServicesMobile: React.FC = () => {
  const router = useRouter();

  const redirectToStore = (store: 'android' | 'ios') => {
    if (store === 'android') {
      window.open('https://play.google.com/store/apps/details?id=com.toyotaargentina.oneapp', '_blank');
    } else if (store === 'ios') {
      window.open('https://apps.apple.com/br/app/toyota-latam/id1597365457', '_blank');
    }
  };

  const handleSaibaMaisClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    router.push('/servicos-conectados');
  };

  return (
    <div className="w-full bg-[#1F1F1F] text-white py-8 px-4 flex flex-col items-start">
      <div className="w-full flex flex-col items-start gap-4">
        <div className="flex items-center">
          <svg width="65" height="67" viewBox="0 0 65 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 45.6035C10.9523 45.8329 19.7607 54.8155 19.7607 65.8633C19.7607 66.0075 19.7579 66.1514 19.7549 66.2949H0V45.6035ZM0.859375 23.1777C23.635 23.1778 42.0986 41.7096 42.0986 64.5693C42.0986 65.1474 42.0839 65.7226 42.0605 66.2949H33.4619C33.4915 65.7235 33.5068 65.1481 33.5068 64.5693C33.5068 46.4721 18.89 31.8018 0.859375 31.8018C0.572057 31.8018 0.285539 31.8041 0 31.8115V23.1885C0.28575 23.1826 0.572226 23.1777 0.859375 23.1777ZM3.43652 0.757812C37.1255 0.757812 64.4355 29.3272 64.4355 64.5693C64.4355 65.1463 64.4286 65.7216 64.4141 66.2949H56.6895C56.6987 65.8648 56.7041 65.4334 56.7041 65.001C56.7041 33.8069 32.6626 8.51855 3.00684 8.51855C1.99782 8.51856 0.995289 8.54768 0 8.60547V0.858398C1.13749 0.79231 2.28324 0.757817 3.43652 0.757812Z" fill="#EB0A1E"/>
          </svg>
          <div className="h-[67px] border-r border-white mx-2"></div>
          <h2 className="text-xl font-bold leading-tight ml-2 text-left">
            TOYOTA<br/><span className="text-[#585958]">SERVIÇOS</span><br/><span className="text-[#585958]">CONECTADOS</span>
          </h2>
        </div>

        <div className="relative w-full flex justify-center items-center">
          <div className="absolute -top-10 right-0 z-10 pointer-events-none top-[-320px]">
            <Image
              src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/mao-a-direita-servicos-conectado.png"
              alt="Mão direita serviços conectados"
              width={700}
              height={400}
              className="object-contain"
              priority
            />
          </div>
        </div>

        <p className="mt-4 text-xl leading-relaxed text-left">
          INFORMAÇÕES E DADOS SOBRE O<br/>VEÍCULO DIRETAMENTE NO CELULAR
        </p>
        <p className="text-red-600 font-bold text-xl mt-2 text-left">
          CONHEÇA ESSA NOVIDADE.
        </p>

        <div className="mt-8 w-full">
          <button className="px-6 py-3 border-2 border-white text-white font-bold rounded-md bg-transparent text-xs w-full"
            onClick={handleSaibaMaisClick}
          >
            SAIBA MAIS
          </button>
        </div>
      </div>

      <div className="mt-8 p-4 flex flex-row items-center justify-center gap-6 bg-opacity-90 rounded-lg w-full max-w-sm">
        <button onClick={() => redirectToStore('android')}>
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/Google Play.svg"
            alt="Disponível no Google Play"
            width={180}
            height={40}
            objectFit="contain"
          />
        </button>
        <button onClick={() => redirectToStore('ios')}>
          <Image
            src="https://bloblandingpageprd.blob.core.windows.net/toyota/geral/home-servicos-conectado/App Store.svg"
            alt="Baixar na App Store"
            width={180}
            height={40}
            objectFit="contain"
          />
        </button>
      </div>

    </div>
  );
};

export default ConnectedServicesMobile;
